import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import {inject, onMounted, reactive, ref} from 'vue'
import {AxiosStatic} from "axios";
import DataTable, {DataTableFilterEvent, DataTablePageEvent} from 'primevue/datatable';
import InputText from 'primevue/inputtext'
import Message from 'primevue/message'
import Column from 'primevue/column';
import moment from "moment";
import WritersMarker from "@/components/blocks/WritersMarker.vue";
import ConfirmDialog from "primevue/confirmdialog";
import {ErrorType} from "@/components/blocks/Types";
import TimelineRowEdit from "@/components/blocks/TimelineRowEdit.vue";
import {TimelineType} from "@/components/blocks/TimelineDefs";

// Define types
type RestResponse = {
  success: boolean,
  message: string | null,
  data: any | null,
  code: number | null
}

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListTimelineTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const timelines = ref<TimelineType[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)
const filters = ref({
  note: {value: '', matchMode: 'contains'},
  projectName: {value: '', matchMode: 'contains'}
})
const displayEdit = ref<boolean>(false)
const selectedRow = ref<any | null>(null)


const error = reactive<ErrorType>({show: false, message: null})
const info = reactive<ErrorType>({show: false, message: null})

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods

function handleRowUpdate(row: TimelineType) {
  loadData()
}

function reloadTable() {
  loadData(mapFilterToDataTablePayload(filters.value))
}

function writeRowToRemote(data: any) {
  const id = data.id
  axios?.post("/timeline/remote-write/" + id, {}).then(response => {
    // TODO update parser according to real response from backend Map<String, RestResponse<RemoteWriteTimestampEntity?>?>
    if (response.status === 200) {
      const result = response.data
      const writers = [...Object.keys(result)]
      let success = true

      const im: string[] = []
      const em: string[] = []

      writers.forEach(item => {
        const sItem = result[item]
        if (sItem != undefined && sItem != null) {
          success = success && sItem.success
          if (sItem.success) {
            im.push("Write to " + item + " success")
          } else {
            em.push("Write to " + item + " failed with message: \" " + sItem.message + "\"")
          }
        } else {
          em.push("Response for writer " + item + " missing!")
        }
      })

      info.show = im.length > 0
      info.message = im.join(". ")

      error.show = em.length > 0
      error.message = em.join(". ")
      loadData()

    } else {
      error.show = true
      error.message = "Write to remote writers failed! " + response.data
    }
  })
}

function editItem(row: any) {
  selectedRow.value = row
  displayEdit.value = true
}

function loadData(filterData: any = {}) {
  loading.value = true
  axios?.post("/datatable/timeline?sort=fromTime&page=" + pageIndex.value + "&pageSize=" + pageSize.value, filterData)
      .then((response) => {
        if (response.status === 200) {
          timelines.value = response.data.rows
        }
        totalRecords.value = response.data.paginator.totalRecords
        loading.value = false
      }).catch(error => {
    console.error('Can not load timeline', error)
    loading.value = false
  })
}

function getDay(row: any): string {
  return moment(row.fromTime).format("dddd")
}

function getTime(dateValue: string): string {
  return moment(dateValue).format("HH:mm")
}

function getDate(dateValue: string): string {
  return moment(dateValue).format("DD.MM.YYYY")
}

function onPage(event: DataTablePageEvent) {
  pageIndex.value = event.page
  loadData()
}

function onFilter(event: DataTableFilterEvent) {
  loadData(mapFilterToDataTablePayload(filters.value))
}

function mapFilterToDataTablePayload(vueFilter: any): any {
  const filter: any = {}
  const keys = Object.keys(vueFilter)
  if (keys === undefined || keys === null || keys.length === 0) {
    return filter
  }
  for (let a = 0; a < keys.length; a++) {
    const key = keys[a]
    const {value: _value, matchMode} = vueFilter[keys[a]]
    if (_value !== null && _value.length > 0) {
      if (key === 'projectName') {
        filter['projectEntity'] = {
          type: getFilterType(matchMode),
          value: '%' + _value + '%',
          childKey: 'name'
        }
      } else {
        filter[key] = {
          type: getFilterType(matchMode),
          value: '%' + _value + '%'
        }
      }
    }
  }
  return filter
}

function getFilterType(vueType: string): string {
  switch (vueType.toUpperCase()) {
    case 'CONTAINS':
      return 'like'
    default:
      return '='
  }
}

// Define exposes
expose({reloadTable})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ConfirmDialog)),
    (timelines.value.length==0)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 0,
          severity: "info",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode("There is not any timeline in database.")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (error.show)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 1,
          severity: "error",
          closable: true,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (error.show=false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.message) + ": " + _toDisplayString(error.show), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (info.show)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 2,
          severity: "info",
          closable: true,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (info.show=false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(TimelineRowEdit, {
      "onUpdate:row": [
        handleRowUpdate,
        _cache[3] || (_cache[3] = ($event: any) => ((selectedRow).value = $event))
      ],
      display: displayEdit.value,
      "onUpdate:display": _cache[2] || (_cache[2] = ($event: any) => ((displayEdit).value = $event)),
      row: selectedRow.value
    }, null, 8, ["display", "row"]),
    _createVNode(_unref(DataTable), {
      class: "p-datatable-sm",
      "auto-layout": true,
      rowHover: true,
      page: pageIndex.value+1,
      ref_key: "dt",
      ref: dt,
      dataKey: "id",
      value: timelines.value,
      lazy: true,
      paginator: true,
      rows: pageSize.value,
      totalRecords: totalRecords.value,
      filterDisplay: "row",
      filters: filters.value,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((filters).value = $event)),
      onPage: _cache[5] || (_cache[5] = ($event: any) => (onPage($event))),
      onFilter: _cache[6] || (_cache[6] = ($event: any) => (onFilter($event))),
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "#" }, {
          body: _withCtx(({data}) => [
            _createElementVNode("i", {
              class: "i-button pi cursor-pointer pi-pencil text-blue-500",
              onClick: ($event: any) => (editItem(data))
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Day" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(getDay(data)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Date" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(getDate(data.fromTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "From" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(getTime(data.fromTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "To" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(getTime(data.toTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "pause",
          header: "Pause"
        }),
        _createVNode(_unref(Column), {
          field: "workTime",
          header: "Worktime"
        }),
        _createVNode(_unref(Column), {
          field: "projectName",
          header: "Project",
          filterMatchMode: "startsWith",
          showFilterMenu: false,
          ref: "projectName"
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_unref(InputText), {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter p-inputtext-sm",
              placeholder: "Project name"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }, 512),
        _createVNode(_unref(Column), {
          field: "note",
          header: "Note",
          showFilterMenu: false
        }, {
          filter: _withCtx(({filterModel,filterCallback}) => [
            _createVNode(_unref(InputText), {
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter p-inputtext-sm",
              placeholder: "Search by note"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "writers",
          header: "Writers"
        }, {
          body: _withCtx(({data}) => [
            _createVNode(WritersMarker, {
              settings: data.remoteWriteTimestamp || null,
              writers: data.writers || null,
              onClick: ($event: any) => (writeRowToRemote(data))
            }, null, 8, ["settings", "writers", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["page", "value", "rows", "totalRecords", "filters", "loading"])
  ], 64))
}
}

})